

document.addEventListener("DOMContentLoaded", function(window, evt){
    var checkForClass = function(element, pClass){
        var nativeMatches = ( element.matches || element.msMatchesSelector );
        try {
            return( nativeMatches.call( element, pClass ) );
        } catch ( error ) {
            return( false );
        }
    }

    var flip = function(coin, value){
        if(value){
            coin.classList.add("flip")
            setTimeout(function(){
              if(!checkForClass(coin, ":hover")){
                  coin.classList.remove("flip")
              }
            }, 3000)
        }else{
            coin.classList.remove("flip")
        }
    }

    var interval
    var coin = document.getElementById("coin")
    coin.addEventListener("mouseleave", function(element, evt){
        flip(this, false)
        interval = setInterval(flip, 18000, coin, true)
    })
    coin.addEventListener("mouseenter", function(element, evt){
        flip(this, true)
        clearInterval(interval)
    })
    interval = setInterval(flip, 18000, coin, true)
})